// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadButton_button__1CtOt"};